/* eslint-disable no-console */
import axios from "axios";
import { acquireToken } from "../auth/authUtils";

const baseUrl = process.env.REACT_APP_BASE_URL;

// Sends a preview of CSV rows for validation with identifying metadata
// meta can be a string (campaignName) or an object e.g. { partnerName } / { campaignName } / { formId }
export const validateCSV = async (meta, rows) => {
  try {
    const accessToken = await acquireToken();
    const payload =
      typeof meta === "string"
        ? { campaignName: meta, data: rows }
        : { ...(meta || {}), data: rows };
    const response = await axios.post(`${baseUrl}/config-validate`, payload, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Validate CSV API call failed:", error);
    throw error;
  }
};

export default validateCSV;
